exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".readingLevelTable{font-size:.8em}.readingLevelTable .table td,.readingLevelTable .table th{vertical-align:middle}.readingLevelTable .studentColumn{width:180px}.readingLevelTable .names{margin-left:35px}.readingLevelTable .names .studentDisplay .name,.readingLevelTable .names .studentListName{text-overflow:ellipsis;overflow:hidden;max-width:10em;white-space:nowrap;display:block}.readingLevelTable .names .studentListName,.readingLevelTable .rlOrigin{color:#999}.dataReadingLevels .readingLevelTable{overflow-x:scroll}.dataReadingLevels .readingLevelTable table td,.dataReadingLevels .readingLevelTable table th{min-width:100px}.dataReadingLevels .readingLevelTable .rldText a{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/reading_levels/reading_level_table.scss
// module id = 1398
// module chunks = 0